import { gql } from '@/__generated__/gql';

export const PACING_TAB_AUTO_PLAN_WIZARD_MODAL_PAGE_LEGAL_ENTITY_QUERY = gql(`
  query PacingTabAutoPlanWizardModalPageLegalEntity($id: String!) {
    legalEntity(id: $id) {
      id
      entityName
      totalEntityValue
      tenant {
        id
      }
      allocationTargets {
        id
        percentage
        assetClass {
          id
          name
          subAssetClass {
            id
            name
          }
        }
      }
      drawdownTargets {
        actuals {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
        targets {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
      }
    }
  }
`);

export const PACING_TAB_AUTO_PLAN_WIZARD_MODAL_PAGE_GROUP_QUERY = gql(`
  query PacingTabAutoPlanWizardModalPageGroup($data: GetGroupInput!) {
    group(data: $data) {
      id
      name
      totalEntityValue
      tenant {
        id
      }
      allocationTargets {
        id
        percentage
        assetClass {
          id
          name
          subAssetClass {
            id
            name
          }
        }
      }
      drawdownTargets {
        actuals {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
        targets {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
      }
    }
  }
`);
